import { Link } from 'react-router-dom';
import { getHotMovies, MovieItem } from '@/mocks/movies';

export default function HotRecommendations() {
  const hotMovies = getHotMovies();

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-2">大家都在看的牛牛超清热门内容</p>
          </div>
          <Link
            to="/category/movie"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap cursor-pointer transition-colors"
          >
            查看全部 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5" data-product-shop="">
          {hotMovies.map((movie: MovieItem) => (
            <Link
              key={movie.id}
              to={`/article/${movie.id}`}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[3/4] rounded-lg overflow-hidden mb-3">
                <img
                  src={movie.image}
                  alt={movie.title}
                  title={`${movie.title} - 牛牛超清在线观看`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 bg-primary-500 text-white text-xs rounded-md font-medium">
                    {movie.rating}
                  </span>
                </div>
                {movie.isNew && (
                  <div className="absolute top-2 right-2">
                    <span className="px-2 py-0.5 bg-accent-500 text-foreground-950 text-xs rounded-md font-medium">
                      新
                    </span>
                  </div>
                )}
                <div className="absolute bottom-0 left-0 right-0 p-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <span className="text-white text-xs bg-primary-500/90 px-3 py-1.5 rounded-full whitespace-nowrap">
                    立即观看
                  </span>
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                {movie.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1">
                {movie.subcategory} · {movie.year}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}